import { render, staticRenderFns } from "./FlashCard.vue?vue&type=template&id=ac746650"
import script from "./FlashCard.vue?vue&type=script&lang=js"
export * from "./FlashCard.vue?vue&type=script&lang=js"
import style0 from "./flashcard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports